import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { Scenario } from '../interfaces/scenario.interface';
import { Observable } from 'rxjs';
import { ScenarioManual } from '../interfaces/scenario-manual';

@Injectable({
  providedIn: 'root'
})
export class ScenarioService {

  constructor(private httpService: HttpService) { }

  public createScenario(data: Scenario): Observable<Scenario> {
    return this.httpService.post<Scenario>('Scenario', data);
  }

  public getScenarioById(id: number): Observable<Scenario> {
    return this.httpService.get<Scenario>('Scenario/' + id);
  }

  public updateScenario(scenarioId: number, scenario: Scenario): Observable<Scenario> {
    let updateScenario = {
      id: scenarioId,
      groupId: scenario.groupId,
      name: scenario.name,
      enabled: scenario.enabled
    } as Scenario
    return this.httpService.put<Scenario>('Scenario/' + scenarioId, updateScenario);
  }

  public deleteScenario(id: number): Observable<void> {
    return this.httpService.delete<void>('Scenario/' + id);
  }

  /* muss noch angepasst werden */
  public addManualControlToScenario(scenarioId: number, manualControlId: number, deId: number): Observable<Scenario> {
    return this.httpService.get<Scenario>(`Scenario/${scenarioId}/add?manualid=${manualControlId}&DEid=${deId}`);
  }

  public removeManuelControlFromScenario(scenarioId: number, ItemId: number): Observable<void> {
    return this.httpService.delete<void>(`Scenario/${scenarioId}/remove/${ItemId}`);
  }

  public getAllScenariosByGroupId(groupId: number): Observable<Scenario[]> {
    return this.httpService.get<Scenario[]>('Scenario/group/' + groupId);
  }

  public enableScenario(scenarioId: number): Observable<any> {
    return this.httpService.get<any>('Scenario/' + scenarioId + '/enable');
  }

  public disableScenario(scenarioId: number): Observable<any> {
    return this.httpService.get<any>('Scenario/' + scenarioId + '/disable');
  }

}
